import React, { forwardRef, useContext } from 'react';
import proptypes from 'prop-types';
const { arrayOf, bool, func, number, shape, string } = proptypes;
import { AddTo } from '@thd-olt-component-react/add-to';
import { Add } from '@one-thd/sui-icons';
import { Button } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { ProductListContext } from '../ProductListContext';

export const AddToMobile = forwardRef(({
  addToProducts,
  addToListProducts,
  handleAddToClick,
  needToLoadProducts,
  noSelectedItems,
  noListSelectedItems
}, ref) => {

  const { productsDisplayed } = useContext(ProductListContext);
  const { isB2BCustomer = false } = useThdCustomer();

  if (!isB2BCustomer) {
    return (
      <AddTo
        addToType="List"
        products={addToListProducts}
        CustomAddToActionElement={({ onClick }) => (
          <Button
            aria-label="Add To List"
            disabled={noListSelectedItems}
            onClick={onClick}
            variant="ghost"
          >
            Add to List
          </Button>
        )}
      />
    );
  }

  return (
    <div ref={ref}>{
      (needToLoadProducts)
        ? (
          <Button
            aria-label="Add To"
            startIcon={Add}
            onClick={(onClick) => handleAddToClick(onClick, '...')}
            variant="tertiary"
          >
            Add To
          </Button>
        )
        : (
          <AddTo
            addToFallbackType={null}
            addToType={null}
            loadedProductsData={productsDisplayed}
            showSelectionScreen
            products={addToProducts}
          />
        )
    }
    </div>
  );
});

AddToMobile.propTypes = {
  addToProducts: arrayOf(shape(
    {
      itemId: string.isRequired,
      price: string,
      productData: shape({
        info: shape({}),
        identifiers: shape({}),
        pricing: shape({})
      }),
      quantity: number,
      sku: shape({
        storeSkuNumber: string,
        omsThdSku: string,
        specialOrderSku: string
      })
    }
  )).isRequired,
  addToListProducts: arrayOf(shape(
    {
      itemId: string,
      intent: string,
      quantity: number
    }
  )),
  handleAddToClick: func.isRequired,
  needToLoadProducts: bool.isRequired,
  noSelectedItems: bool.isRequired,
  noListSelectedItems: bool
};

AddToMobile.defaultProps = {
  addToListProducts: [],
  noListSelectedItems: true
};